import React from 'react';
import './Controllers.css';

type Props = {
    adjustDepth: (delta: number) => void;
    depth: number;
};

const DepthController = ({ adjustDepth, depth }: Props) => (
    <div className="depthController">
        Depth Control: {depth}
        {depth >= 0 && (
            <>
                <input type="button" value="▲" onClick={() => adjustDepth(depth + 1)} />
                <input type="button" value="▼" onClick={() => adjustDepth(depth - 1)} />
            </>
        )}
    </div>
);

export default DepthController;
